import type { ReactNode } from "react";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { ContactCountBadge } from "../contacts/ContactCountBadge";

export type AsideSectionProps = {
  title: string;
  children?: ReactNode;
  noGap?: boolean;
  badgeCount?: number;
};

export function AsideSection({
  title,
  children,
  noGap,
  badgeCount,
}: AsideSectionProps) {
  const isMobile = useIsMobile();
  return (
    <div className="mb-6 text-sm">
      <h3
        className={
          isMobile
            ? "text-lg font-semibold inline-flex items-center gap-1.5"
            : "font-medium pb-1 inline-flex items-center gap-1.5"
        }
      >
        {title}
        {badgeCount != null && badgeCount > 0 && (
          <ContactCountBadge count={badgeCount} />
        )}
      </h3>
      <Separator />
      <div className={cn("pt-2 flex flex-col", { "gap-1": !noGap })}>
        {children}
      </div>
    </div>
  );
}
